import { CaretDownIcon } from "@phosphor-icons/react/dist/csr/CaretDown";
import { FunnelSimpleIcon } from "@phosphor-icons/react/dist/csr/FunnelSimple";
import { Button } from "@volca/ui/components/ui/button";
import {
  DropdownMenu,
  DropdownMenuCheckboxItem,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuSeparator,
  DropdownMenuTrigger,
} from "@volca/ui/components/ui/dropdown-menu";
import type { FindingRuleCount } from "./types";

/** Rule choices come from the full status/period scope, not the loaded rows. */
export const ReviewRuleFilter = ({
  rules,
  selected,
  onChange,
  pending,
}: {
  rules: FindingRuleCount[];
  selected: string[];
  onChange: (rules: string[]) => void;
  pending: boolean;
}) => {
  const options = [
    ...rules,
    ...selected
      .filter((rule) => !rules.some((item) => item.rule === rule))
      .map((rule) => ({ rule, count: 0 })),
  ];
  const label =
    selected.length === 0
      ? "All rules"
      : selected.length === 1
        ? selected[0]
        : `${selected.length} rules`;

  return (
    <DropdownMenu>
      <DropdownMenuTrigger
        render={
          <Button
            variant="ghost"
            size="sm"
            className="-me-2 min-w-0"
            aria-label={`Filter by rule: ${label}`}
            disabled={pending}
          />
        }
      >
        <FunnelSimpleIcon aria-hidden />
        <span>Rules</span>
        {selected.length > 0 && (
          <span className="text-subtle tabular-nums">{selected.length}</span>
        )}
        <CaretDownIcon aria-hidden />
      </DropdownMenuTrigger>
      <DropdownMenuContent
        align="start"
        className="max-h-80 w-72 overflow-y-auto pointer-coarse:[&_[role^=menuitem]]:min-h-11"
      >
        <DropdownMenuItem
          onClick={() => onChange([])}
          disabled={selected.length === 0}
        >
          All rules
        </DropdownMenuItem>
        <DropdownMenuSeparator />
        {options.map((item) => (
          <DropdownMenuCheckboxItem
            key={item.rule}
            checked={selected.includes(item.rule)}
            closeOnClick={false}
            onCheckedChange={(checked) =>
              onChange(
                checked
                  ? [...selected, item.rule]
                  : selected.filter((rule) => rule !== item.rule),
              )
            }
          >
            <span className="min-w-0 flex-1 text-wrap">{item.rule}</span>
            <span className="text-subtle tabular-nums">{item.count}</span>
          </DropdownMenuCheckboxItem>
        ))}
      </DropdownMenuContent>
    </DropdownMenu>
  );
};
